module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1 unnumbered",
    staticStyle: {
      "padding-left": "50px"
    },
    attrs: {
      "id": "section"
    }
  }, [_c('div', {
    staticClass: "section level3",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('div', {
    staticClass: "section level5",
    attrs: {
      "id": "to-kusha-and-to-the-earth-we-walked."
    }
  }, [_c('h2', {
    staticStyle: {
      "text-align": "center",
      "padding-top": "100px",
      "width": "550px",
      "letter-spacing": "1.5px"
    }
  }, [_vm._v("Acknowledgements")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "550px"
    }
  }, [_c('p', {
    staticStyle: {
      "width": "550px",
      "text-indent": "0px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("In 2016 I met Elizabeth Ellis, Emeritus Curator of the Mitchell Library at the State Library of New South Wales, who suggested that I should write down what I had told her in our conversation. She helped me through the start-up of this book, and I am thankful for her patience and guidance. Since then much has changed, and she may be surprised to see the book in its final form.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "text-indent": "0px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("I am also grateful to Kusha, my companion in exploring life in an age of rapid changes, I thank her and my family for putting up with me whist writing our story. I am obliged to the photographers and artists who allowed their work to serve as illustration, and to Walter Stephenson, who guided the production of this volume. Thank you all.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "text-indent": "0px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("Aberfeldy, spring 2020 "), _c('br'), _vm._v("Dirk Bolt")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "padding-top": "90px",
      "text-indent": "0px",
      "font-family": "calibri",
      "font-size": "10pt",
      "width": "550px"
    }
  }, [_vm._v("The cover shows the capital of Tasmania, Australia’s island state. In the centre is the River Derwent, and in the foreground the City of Hobart. Beyond the right of the scene is Storm Bay, and in the distance a glimpse of the Tasman Sea. The picture was taken from Mount Wellington by Nick Pitsas, CSIRO, in 2006. (scienceimage.csiro.au)")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd89e44e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0004.vue
// module id = 69
// module chunks = 0